// NEOGRIPX — "Este diseño, a tu manera" (snippet nx-recolor)
// Etiqueta de la foto con su ventana, y franja: mandan la consulta por
// WhatsApp con el mensaje ya escrito.
(function () {
  const blocks = document.querySelectorAll('[data-nxr]');
  if (!blocks.length) return;

  // Tipo de bici elegido en la ficha, si lo hay
  const bikeType = () => {
    const r = document.querySelector('#AddToCartForm .variant-radio:checked');
    return r ? r.value : '';
  };

  blocks.forEach((root) => {
    const dialog = root.querySelector('[data-nxr-dialog]');
    const open = root.querySelector('[data-nxr-open]');
    if (dialog && open) {
      open.addEventListener('click', () => { if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', ''); });
      root.querySelector('[data-nxr-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    }

    root.querySelectorAll('[data-nxr-send]').forEach((btn) => btn.addEventListener('click', () => {
      let msg = `Hola NEOGRIPX, me gusta el kit ${root.dataset.design} y me gustaría personalizarlo a mi gusto (colores, degradados, detalles…).`;
      const bike = bikeType();
      if (bike) msg += ` Mi bici es ${bike}.`;
      msg += ' ¿Me contáis cómo funciona?';
      window.open(`https://wa.me/${root.dataset.wa}?text=${encodeURIComponent(msg)}`, '_blank', 'noopener');
    }));
  });
})();
